import { Box, TextField, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { generateClient } from 'aws-amplify/api';
import { Schema } from '../../../amplify/data/resource';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { useSnackbar } from 'notistack';

interface Props {
  popoverRef: React.RefObject<HTMLDivElement>;
  handleClosePopover: () => void;
}

const apiClient = generateClient<Schema>();

const Support: React.FC<Props> = ({ popoverRef, handleClosePopover }) => {
  const [caseNumber, setCaseNumber] = useState<string>('');
  const [caseText, setCaseText] = useState<string>('');
  const userId = '';

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const generateUniqueID = () => {
      const shortUUID = uuidv4().split('-')[0];
      const timestamp = Date.now();

      return `${shortUUID}`;
    };
    setCaseNumber(generateUniqueID());
  }, []);

  const sendMail = async () => {
    const userAttributes = await fetchUserAttributes();
    console.log(userAttributes);

    const emailVerified =
      userAttributes.email_verified === 'true' ? 'verified' : 'unverified';
    const phoneVerified =
      userAttributes.phone_number_verified === 'true'
        ? 'verified'
        : 'unverified';

    const body = `
      <html>
        <body>
          <h2>User Info:</h2>
          <p><strong>Name:</strong> ${userAttributes.name}</p>
          <p><strong>Email:</strong> ${userAttributes.email} (${emailVerified})</p>
          <p><strong>Phone Number:</strong> ${userAttributes.phone_number} (${phoneVerified})</p>
          <br><br>
          <h2>Case Text:</h2>
          <p>${caseText}</p>
        </body>
      </html>
    `;

    const response = await apiClient.queries.sendEmail({
      to: 'service@pielapay.com',
      from: 'no-reply@pielapay.co.il',
      subject: `Case ${caseNumber}`,
      body: body,
    });

    enqueueSnackbar('פנייה נשלחה בהצלחה', {
      variant: 'success',
    });

    handleClosePopover();

    console.log('Email response:', response);
  };

  return (
    <Box
      ref={popoverRef}
      sx={{
        position: 'absolute',
        top: `550px`,
        borderRadius: '30px',
        left: `-490px`,
        backgroundColor: '#424245F5',
        width: '549px',
        padding: '30px',
        color: '#fff',
        zIndex: 1500,
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          gap: '40px',
        }}
      >
        <img
          alt="Light"
          src="/assets/sidebar/light/large.svg"
          style={{ marginTop: '-40px' }}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <Typography
            textAlign={'right'}
            fontWeight={'700'}
            fontSize={'16px'}
            fontFamily={'AlmoniDL'}
            color={'#7AED20'}
          >
            הזמנת מומחה
          </Typography>
          <Box
            sx={{
              backgroundColor: '#E7ECF2',
              width: '470px',
              borderRadius: '30px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <TextField
              variant="outlined"
              fullWidth
              placeholder="הכנס טקסט..."
              inputProps={{ dir: 'rtl', maxLength: 250 }}
              multiline
              maxRows={4}
              sx={{
                backgroundColor: 'transparent',
                borderRadius: '30px',
                input: {
                  padding: '10px 15px',
                  color: '#000',
                  '::placeholder': {
                    color: '#B0B0B0',
                  },
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
              }}
              value={caseText}
              onChange={(e) => setCaseText(e.target.value)}
              onKeyDown={(e) => {
                const textArea = e.target as HTMLTextAreaElement;
                const lineCount = textArea.value.split('\n').length;

                if (lineCount >= 4 && e.key === 'Enter') {
                  e.preventDefault();
                }
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
            gap: '20px',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#3A3A3A',
              borderRadius: '15px',
              width: '66px',
              height: '66px',
            }}
            onClick={handleClosePopover}
          >
            <Icon
              icon={'material-symbols:close'}
              style={{ width: '30px', height: '30px' }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
            <Typography
              textAlign={'right'}
              fontWeight={'700'}
              fontSize={'16px'}
              fontFamily={'AlmoniDL'}
            >
              מספר פניה
            </Typography>
            <Typography
              textAlign={'right'}
              fontWeight={'700'}
              fontSize={'16px'}
              fontFamily={'Montserrat'}
            >
              {caseNumber}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#7AED204A',
              borderRadius: '15px',
              width: '51px',
              height: '69px',
            }}
            onClick={() => sendMail()}
          >
            <img alt="Arrow" src="/assets/sidebar/light/arrow.svg" />
          </Box>
          <Typography
            textAlign={'right'}
            fontWeight={'700'}
            fontSize={'16px'}
            fontFamily={'AlmoniDL'}
            color={'#C1FE40'}
          >
            שליחה
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Support;
